import { g as getLocale, t as trackMessageCall } from "./runtime.js";
const en_verification = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `shrtn | Verification`;
  }
);
const de_verification = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `shrtn | Verifizierung`;
  }
);
const sp_verification = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `shrtn | Verificación`;
  }
);
const verification = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("verification", locale);
  if (locale === "en") return en_verification();
  if (locale === "de") return de_verification();
  return sp_verification();
};
const en_verification_mail_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Welcome to shrtn`;
  }
);
const de_verification_mail_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Willkommen bei shrtn`;
  }
);
const sp_verification_mail_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Bienvenido a shrtn`;
  }
);
const verification_mail_headline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("verification_mail_headline", locale);
  if (locale === "en") return en_verification_mail_headline();
  if (locale === "de") return de_verification_mail_headline();
  return sp_verification_mail_headline();
};
const en_verification_mail_body = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Please enter the following key on the page that opens after you have entered your e-mail. This key only works on this website.`;
  }
);
const de_verification_mail_body = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Bitte gebe den folgenden Schlüssel auf der Seite ein, die sich nach der Eingabe Deiner E-Mail geöffnet hat. Dieser Schlüssel funktioniert nur auf dieser Seite.`;
  }
);
const sp_verification_mail_body = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Por favor, introduce la siguiente clave en la página que se abrió después de introducir tu correo electrónico. Esta clave solo funciona en esa página.`;
  }
);
const verification_mail_body = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("verification_mail_body", locale);
  if (locale === "en") return en_verification_mail_body();
  if (locale === "de") return de_verification_mail_body();
  return sp_verification_mail_body();
};
export {
  verification_mail_body as a,
  verification_mail_headline as b,
  verification as v
};
